module.exports = __webpack_public_path__ + "static/media/IA.6c725854.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/IA.png
// module id = 516
// module chunks = 0